import StructureModel from '@Components/Results/structure/structure-model.service';
import { formatStructureAvailabilityUrls } from '@Pages/RetroSynthesis/components/RsStructure/utils';

// eslint-disable-next-line import/prefer-default-export
export class StructureOptionHelper {
  static extractData = (data) => {
    try {
      const { subDetails, path, structure, availability, ...rest } = data.substance;
      const result = {
        details: subDetails,
        molImage: {
          path,
          structure,
        },
        availability: formatStructureAvailabilityUrls(availability),
        ...rest,
      };
      return new StructureModel(result);
    } catch (e) {
      Logger.error('extractData error', e);
      return false;
    }
  };
}
